<template>
  <w-settings-detail :title="title" :menu="menu" :default-active-menu="defaultMenu" @change="onChangeMenu">
    <component slot="activeView" :is="activeMenu"></component>
  </w-settings-detail>
</template>

<script>
import WSettingsDetail from '@/components/template/SettingsDetail';
import WOperationPort from './OperationPort';
import WDataRetentionRange from './DataRetentionRange';
import WAgentSettings from './AgentSettings';
import WRscSettings from './RscSettings';
import WSnapshotPeriodSettings from './SnapshotPeriodSettings';

const defaultMenu = 'WAgentSettings';
export default {
  name: 'WCollectionSettings',
  components: {
    WSettingsDetail,
    WOperationPort,
    WDataRetentionRange,
    WAgentSettings,
    WRscSettings,
    WSnapshotPeriodSettings,
  },
  props: {
    title: String,
  },
  data() {
    return {
      defaultMenu,
      activeMenu: 'WAgentSettings',
      menu: [
        {
          id: 'WAgentSettings',
          name: '수집서버 설정',
          active: false,
        },
        {
          id: 'WRscSettings',
          name: '수집 자원 설정',
          active: false,
        },
        {
          id: 'WDataRetentionRange',
          name: '수집 데이터 보유기간',
          active: false,
        },
        {
          id: 'WOperationPort',
          name: '수집 포트 설정',
          active: false,
        },
        {
          id: 'WSnapshotPeriodSettings',
          name: '스냅샷 주기 설정',
          active: false,
        },
      ],
    };
  },
  methods: {
    onChangeMenu(menu) {
      this.activeMenu = menu;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/operation/CollectionSettings/index.vue